import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../../../core/_base/crud';
import { AffiliationRelationState } from '../reducers';
import { AffiliationRelation } from '../models';

export const selectAffiliationRelationState =
  createFeatureSelector<AffiliationRelationState>('affiliationRelation');

export const selectAffiliationRelationPageLoading = createSelector(
  selectAffiliationRelationState,
  (state) => state.pageLoading,
);

export const selectAffiliationRelationActionLoading = createSelector(
  selectAffiliationRelationState,
  (state) => state.actionLoading,
);

export const selectAffiliationRelationShowInitWaitingMessage = createSelector(
  selectAffiliationRelationState,
  (state) => state.showInitWaitingMessage,
);

export const selectAffiliationRelationError = createSelector(
  selectAffiliationRelationState,
  (state) => state.error,
);

export const selectAffiliationRelationPage = createSelector(
  selectAffiliationRelationState,
  (state) => {
    const affiliationRelations: AffiliationRelation[] = [];
    each(state.ids, (id: number) => affiliationRelations.push(state.entities[id]));

    return new QueryResultsModel(affiliationRelations, state.totalCount);
  },
);
